<template>
    <b-card>
        <h6>Set Distribution Status</h6>
        <b-button class="w-100" @click="setAction('approve')" variant="success">Approve</b-button>
        <b-button class="w-100 mt-1"  @click="setAction('reject')" variant="danger">Reject</b-button>
    </b-card>

</template>

<script>
export default {
    data:() => ({}),
    computed:{},
    methods:{
        setAction(type){
            this.$eventHub.$emit('distributionAction', type);
        }
    },
    mounted(){},
}
</script>

<style>

</style>